module.exports = __webpack_public_path__ + "img/health6_7-9-2021.54b35645.jpg";